export default "__VITE_ASSET__CsYCYyru__"